import {baseBackendUrl} from "../shared/constants";

export async function sendReport(message) {
    const token = localStorage.getItem("token");
    const response = await fetch(`${baseBackendUrl}/reports/send`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ message }),
    });
    if (!response.ok) {
        throw new Error("Ошибка при отправке репорта");
    }
    return response.json();
}

export async function fetchUserReports() {
    const token = localStorage.getItem("token");
    const response = await fetch(`${baseBackendUrl}/reports/user`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    });
    if (!response.ok) {
        throw new Error("Ошибка загрузки репортов");
    }
    return response.json();
}